import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from "@angular/router";
import { Observable, of } from "rxjs";
import { ApiService } from "../shared/services/api.service";
import { catchError, map, tap } from "rxjs/operators";
import { ToastrService } from "ngx-toastr";
import { TranslateService } from "@ngx-translate/core";

@Injectable({
  providedIn: "root"
})
export class PasswordTokenGuard implements CanActivate {
  constructor(private translate: TranslateService, private apiService: ApiService, private router: Router,  private toastr: ToastrService) { }

  /**
    * This security guard checks the password reset token in the URL for the administrator user. If it is valid, it allows the password reset to proceed.
    * This security guard checks the URL for a `tokenPassword` parameter and verifies it with the backend API.
   */
  canActivate(): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {    
    // Check if tokens already exist in localStorage (for page reloads)
    const urlParams = new URLSearchParams(window.location.search);
    var  tokenPassword = urlParams.get('tokenPassword');

    if (!tokenPassword) {
      // Token already exists, allow access
         tokenPassword = localStorage.getItem('token_reset_password');
    } 

    if (tokenPassword) {
      return this.apiService.verifyPasswordToken(tokenPassword).pipe(
        // Handle the response from the API service
        tap(response => {
          localStorage.setItem('token_reset_password', response.accessToken);
        }),
        // If the token is valid, allow the route activation
        map(() => true),
        // If an error occurs, deny the route activation
        catchError((err) => {
            if(err.error.code === 401){
              this.toastr.error(
                this.translate.instant('texto_954'),
                this.translate.instant('texto_892'),
                {
                  closeButton: true,
                  tapToDismiss: false
                }
            );
          } else {
            this.toastr.error(
              this.translate.instant('texto_890'),
              this.translate.instant('texto_892'),
                {
                    closeButton: true,
                    tapToDismiss: false
                }
            );
          }
          this.router.navigate(["inicio"]);
          localStorage.removeItem('token_reset_password');
          return of(false);
        })
      );
    } 
    else {
      this.toastr.error(
        this.translate.instant('texto_890'),
        this.translate.instant('texto_892'),
          {
              closeButton: true,
              tapToDismiss: false
          }
       );
      localStorage.removeItem('token_reset_password');
      this.router.navigate(["inicio"]);
      return false;
    }
  }
}
